<!--
 * @description: 商品列表 左边 商品
 * @Author: Jay
 * @Date: 2021-09-25 09:57:16
 * @LastEditors: Jay
 * @LastEditTime: 2022-02-15 11:02:50
-->
<template>
  <div>
    <div
      class="swiper"
      @mouseover="mouseOver"
      @mouseleave="mouseLeave"
      v-if="goodsData[tabIndex].goods != ''"
    >
      <!-- 轮播图 -->
      <swiper class="swiper-top" :options="swiperOption">
        <swiper-slide
          class="swiper-item"
          v-for="(slide, index) in goodsData[tabIndex].goods"
          :key="index"
        >
          <!-- 跳转 商品详情-->
          <!-- <router-link to="/CulturalDetails"> -->
          <div @click="skipDetails(index)">
            <!-- 图片 -->
            <div class="item-code">
              <img class="item-img" :src="$api + slide.images" alt="" />
            </div>
            <!-- 标题 -->
            <div
              class="font_size_df padding-top text-cut text-black text-align"
            >
              {{ slide.goods_name }}
            </div>
          </div>
          <!-- </router-link> -->
        </swiper-slide>
        <!-- 左右切换 -->
        <div
          class="swiper-button-prev garden"
          slot="button-prev"
          v-show="showlRBu"
        ></div>
        <div
          class="swiper-button-next garden"
          slot="button-next"
          v-show="showlRBu"
        ></div>
      </swiper>
    </div>
    <!-- 内容为空显示 -->
    <div v-else>
      <el-result icon="info" title="内容为空" subTitle="请联系管理员及时更新">
      </el-result>
    </div>
  </div>
</template>

<script>
//页面引入swiper
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  name: "goodeRightList",
  props: ["goodsData", "tabIndex"],
  data() {
    return {
      //轮播图 配置
      swiperOption: {
        slidesPerView: 3,
        // centeredSlides: true,
        // centeredSlidesBounds: true,
        //间隔
        spaceBetween: 30,
        //每次滑动滚动的数量
        slidesPerGroup: 1,
        //循环播放
        // loop: true,
        //自动轮播
        // autoplay: {
        //   delay: 3000,
        //   stopOnLastSlide: false,
        //   disableOnInteraction: true,
        // },
        //左右标签
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
      },
      //是否显示 左右切换按钮
      showlRBu: false,
    };
  },
  components: {
    swiper,
    swiperSlide,
  },
  methods: {
    //移入
    mouseOver() {
      this.showlRBu = true;
    },
    //移除
    mouseLeave() {
      this.showlRBu = false;
    },
    //跳转详情
    skipDetails(index) {
      //使用vuex 暂时缓存 数据
      this.$store.state.articleConter = {
        id: index,
        list: this.goodsData[this.tabIndex].goods,
      };
      //$router的两个API
      this.$router.push({
        path: "/CulturalDetails",
        // query: {
        //   id: xxx,
        //   title: xxx,
        // },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
//
.swiper {
  width: 45vw;
  position: relative;
}
//轮播图
.swiper-top {
  position: absolute;
  left: -40px;
  width: 49vw;
  .swiper-item {
    // width: 360px;
    width: 390px !important;
    height: 500px;
    background-color: #fff;
  }
}

//圆角
.garden {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #fafafa;
}

//轮播图 内容
.item-code {
  overflow: hidden;
  .item-img {
    // width: 100%;
    width: 390px;
    height: 390px;
    transition: all 0.6s;
    object-fit: fill;
  }
  .item-img:hover {
    transform: scale(1.4);
  }
}
</style>